<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>
#app {
}
.fa-icon {
  vertical-align: middle;
}

.vue-object-view button {
  font-size: xx-small;
}
</style>



// WEBPACK FOOTER //
// App.vue?060e66b6